export function formatHistoryDateTime(value) {
  if (!value) return { dateText: "N/A", timeText: "" };
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return {
      dateText: value,
      timeText: "",
    };
  }

  return {
    dateText: date.toLocaleDateString(undefined, {
      year: "numeric",
      month: "short",
      day: "numeric",
    }),
    timeText: date.toLocaleTimeString(undefined, {
      hour: "numeric",
      minute: "2-digit",
      second: "2-digit",
    }),
  };
}

export function formatBarcodeSerial(value) {
  if (!value) return "N/A";
  const barcode = String(value);
  if (barcode.length <= 15) return barcode;
  return `...${barcode.slice(-15)}`;
}

export function getHistoryActionBadgeClass(action) {
  const text = (action || "").toLowerCase();
  if (text.includes("remove") || text.includes("delete")) {
    return "bg-red-100 text-[#DC2626]";
  }
  if (text.includes("scan") || text.includes("creation")) {
    return "bg-green-100 text-green-700";
  }
  if (text.includes("adjust")) {
    return "bg-amber-100 text-[#B45309]";
  }
  if (text.includes("transfer")) {
    return "bg-blue-100 text-[#2563EB]";
  }
  return "bg-[#EFF6FF] text-[#0F172A]";
}

export function formatHistoryContextSummary(event) {
  const action = String(event?.action || "").toLowerCase();
  const context = event?.context;

  if (action === "transfer") {
    const fromLabel =
      context?.from_zone?.label || context?.from_location?.label || null;
    const toLabel = context?.to_zone?.label || context?.to_location?.label || null;
    if (fromLabel && toLabel) {
      return `${fromLabel} → ${toLabel}`;
    }
    if (fromLabel || toLabel) {
      return [fromLabel, toLabel].filter(Boolean).join(" → ");
    }
  }

  const shipping = context?.shipping;
  if (shipping?.po_number) {
    return `PO ${shipping.po_number}`;
  }
  if (shipping?.invoice_number) {
    return `Inv. ${shipping.invoice_number}`;
  }

  return "—";
}

export function historyRowKey(event, index) {
  return event?.id ?? `${event?.barcode ?? "event"}-${index}`;
}
